module.exports = "/_next/static/images/check-duotone-4917934ebd5747bba6847e9a679c7985.svg";